export const BOOKMAKER_NAMES_LOOKUP = {
  SB2: 'Sportsbet',
  BF: 'Betfair',
  LB: 'LuxBet',
  SB5: 'SportsBetting',
  N: 'TAB NSW',
  TS_N: 'TAB Fixed NSW',
  V: 'TAB VIC',
  TS_V: 'TAB Fixed VIC',
  Q: 'UBET',
  TS_Q: 'TAB Fixed QLD',
  NZ: 'NZ TAB',
  BE: 'BetEasy',
  CB: 'Centrebet',
  BB2: 'BestBookies',
  TS2: 'TopSport',
  BT: 'Bet365',
  OB: 'TABTouch',
  WH: 'William Hill UK',
  LB2: 'Ladbrokes',
  LB2U: 'Ladbrokes UK',
  UB: 'Unibet',
  CB2: 'PlayUp',
  TB2: 'TopBetta',
  OP: 'Official Price',
  BV: 'BetVictor',
  SB6: 'SkyBet',
  CB3: 'Coral',
  BS3: 'BoyleSports',
  RB2: 'RaceBets',
  GT: 'Global Tote',
  ND: 'Neds',
  BB3: 'BlueBet',
  BB4: 'BBet',
  BD: 'Betdogs',
  RB3: 'Real Bookie',
  RW: 'Rob Waterhouse',
  TB3: 'TexBet',
  PB4: 'PicnicBet',
  DD: 'Dave Dwyer',
  BD2: 'Bet Deluxe',
  MN: 'Monmouth Park',
  PS2: 'PlaySQR',
  CY: 'Caymanasbet',
  CB4: 'Crossbet',
  PN: 'Pronet',
  WB2: 'Wishbet',
  ZB: 'ZBet',
  PB5: 'Punt123Bet',
  MB: 'Marantellibet',
  GSB: 'Getsetbet',
  WB3: 'Winbet',
  FXC: 'FoxCatcher',
  BF3: 'BetFlux',
  BN: 'BetNation',
  UC: 'UpCoz',
  MNB: 'MiniBet',
  BB: 'BaggyBet',
  RB5: 'ReadyBet',
  BG: 'BetGold',
  BSB: 'BossBet',
  OKE: 'OkeBet',
  SB3: 'SwiftBet',
  RB4: 'RamBet'

  // SB: 'William Hill',
}

export const COUNTRY_CODE = {
  AU: 'Australia',
  CA: 'Canada',
  FR: 'France',
  HK: 'Hong Kong',
  IE: 'Ireland',
  JP: 'Japan',
  NZ: 'New Zealand',
  SG: 'Singapore',
  ZA: 'South Africa',
  GB: 'United Kingdom',
  US: 'United States',
  SE: 'Sweden'
}

export const RACE_TYPE = {
  THOROUGHBRED: 'Thoroughbred',
  GREYHOUND: 'Greyhound',
  HARNESS: 'Harness'
}

export const BET_TYPE = {
  dailydouble: 'Daily Double',
  derivative: 'Derivative',
  exacta: 'Exacta',
  firstfour: 'First Four',
  multi: 'Multi',
  place: 'Place',
  quaddie: 'Quaddie',
  quinella: 'Quinella',
  trifecta: 'Trifecta',
  win: 'Win'
}

export const TICKET_TYPES = {
  0: 'UNRESULTED',
  1: 'PAID',
  2: 'REJECTED',
  3: 'PARTIAL',
  4: 'PENDING',
  5: 'REFUNDED',
  6: 'CANCELLED'
}
